import { ProgressBar } from '@infl-ts/ui-advocate-components';
import { AppBar, Button, Typography } from '@mui/material';
import { constVoid, pipe } from 'fp-ts/function';
import { Header } from '../challenge-player/challenge-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var OnboardingSkipButton = function OnboardingSkipButton() {
  return /*#__PURE__*/_jsx(Button, {
    sx: {
      color: function color(t) {
        return t.palette.neutral.main;
      }
    },
    variant: "text",
    onClick: constVoid,
    "data-element": "Button",
    "data-component": "OnboardingSkipButton",
    "data-source-file": "challenge-header.tsx",
    children: "Skip Onboarding"
  });
};

var ChallengeHeader = function ChallengeHeader(_ref) {
  var headline = _ref.headline,
      stageIndex = _ref.stageIndex,
      totalStages = _ref.totalStages,
      skippableOnboarding = _ref.skippableOnboarding;
  return /*#__PURE__*/_jsxs(AppBar, {
    sx: {
      boxShadow: 'none',
      zIndex: function zIndex(t) {
        return t.zIndex.abovePopover;
      }
    },
    color: "transparent",
    position: "sticky",
    "data-element": "AppBar",
    "data-component": "ChallengeHeader",
    "data-source-file": "challenge-header.tsx",
    children: [/*#__PURE__*/_jsxs(Header, {
      sx: {
        py: 2,
        px: 3,
        height: 76,
        flexDirection: 'row',
        alignItems: 'center'
      },
      "data-element": "Header",
      "data-component": "ChallengeHeader",
      "data-source-file": "challenge-header.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        dangerouslySetInnerHTML: {
          __html: headline
        },
        "data-element": "Typography",
        "data-component": "ChallengeHeader",
        "data-source-file": "challenge-header.tsx"
      }), skippableOnboarding ? /*#__PURE__*/_jsx(OnboardingSkipButton, {}) : null]
    }), pipe((stageIndex + 1) / totalStages * 100.0, function (progressPercent) {
      return /*#__PURE__*/_jsx(ProgressBar, {
        color: "primary",
        progress: progressPercent
      });
    })]
  });
};

export default ChallengeHeader;